export default class ErrorService{

  constructor(config, AuthService, $filter, $uibModal){
    this.config = config;
    this.AuthService = AuthService;
    this.$filter = $filter;
    this.$uibModal = $uibModal;
  }

  showError(error, text){
    var body = [
      "Táto správa obsahuje podrobnosti o chybe, stave systému a o užívateľovi ktorý chybu vyvolal.",
      "Hlásenie prosím odošlite na: "+this.config.helpdesk,
      "===== DOPLNTE POPIS PROBLÉMU ====",
      "",
      "=================================",
      "",
      "Adresa chyby:",
      window.location.href,
      "",
      "Informácie o užívateľovi",
      JSON.stringify(this.AuthService.user),
      "",
      "Informácie o chybe",
      this.$filter('json')(error)
    ];
    return this.openErrorDialog(body.join("\n"), text, error);
  }

  openErrorDialog(errorBody, header, error){
    return this.$uibModal.open({
      template: require("./ErrorModal.html"),
      controller: function($uibModalInstance){
        this.header = header;
        this.text = errorBody;
        this.error = error;
        this.ok = function(){
          $uibModalInstance.close();
        }
      },
      controllerAs: 'ctrl',
    }).result;
  }


}


// WEBPACK FOOTER //
// ./src/util/ErrorService.js